module.exports = __webpack_public_path__ + "static/media/card_small_3.f2fa18f9.svg";